export default __webpack_public_path__ + "static/media/salon.75de13a5.jpg";